import { DropDownNameOptions } from '@via/models';

export enum ParticipantType {
  Individual = 'Individual',
  Corporate = 'Corporate',
}

export enum AllParticipants {
  CaseDesignation = 'Case Designation',
  Client = 'Client',
  CourtDesignation = 'Court Designation',
  Vendor = 'Vendor',
  PlainTiff = 'Plaintiff',
}

export type AllParticipantModel = {
  [AllParticipants.Client]: {
    id: 1;
    label: AllParticipants.Client;
    alias: 'client';
  };
  [AllParticipants.PlainTiff]: {
    id: 2;
    label: AllParticipants.PlainTiff;
    alias: 'plainTiff';
  };
  [AllParticipants.CourtDesignation]: {
    id: 3;
    label: AllParticipants.CourtDesignation;
    alias: 'courtDesignation';
  };
  [AllParticipants.Vendor]: {
    id: 4;
    label: AllParticipants.Vendor;
    alias: 'vendor';
  };
  [AllParticipants.CaseDesignation]: {
    id: 5;
    label: AllParticipants.CaseDesignation;
    alias: 'caseDesignation';
  };
};

export const ParticipantModel = {
  [AllParticipants.Client]: {
    id: 1,
    label: AllParticipants.Client,
    alias: 'caseDesignation',
  },
  [AllParticipants.PlainTiff]: {
    id: 2,
    label: AllParticipants.PlainTiff,
    alias: 'client',
  },
  [AllParticipants.CourtDesignation]: {
    id: 3,
    label: AllParticipants.CourtDesignation,
    alias: 'courtDesignation',
  },
  [AllParticipants.Vendor]: {
    id: 4,
    label: AllParticipants.Vendor,
    alias: 'vendor',
  },
  [AllParticipants.CaseDesignation]: {
    id: 5,
    label: AllParticipants.CaseDesignation,
    alias: 'caseDesignation',
  },
};

export enum ParticipantTypeRouteModel {
  'Case Designation' = 'case-designation',
  'Client' = 'client',
  'Plaintiff' = 'plaintiff',
  'Vendor' = 'vendor',
  'Court Designation' = 'court-designation',
}

export type BKDistrictInfo = {
  districtName: string;
  divisionName: string | null;
  courtName: string | null;
  judgeName: string | null;
  id: number;
};

export type ParticipantsGetByIdData = {
  id: number;
  participantData: string;
  participantType: string;
  createdById: number;
  modifiedById: number;
  createdDateTime: string;
  isActive: boolean;
  isCorporate: boolean;
};

export type ParticipantFormTypes = 'Individual' | 'Corporate';

export type ParticipantRoles = {
  id: number;
  name: string;
  isActive: boolean;
  participantTypeId: number;
  createdDateTime: string;
  createdById: null | number;
  modifiedById: null | number;
  participantType: null | string;
};

export enum CaseParticipantStatuses {
  ACTIVE = 'Active',
  INACTIVE = 'Inactive',
}

export enum CaseParticipantTypes {
  PARTY = 'Party',
  VENDOR = 'Vendor',
  CLIENT = 'Client',
  TENANT = 'Tenant',
  BENEFICIARY = 'Beneficiary',
}

export type CaseParticipant = {
  id: number;
  name: string;
  type: CaseParticipantTypes;
  status?: CaseParticipantStatuses;
  address?: string;
  role?: string;
};

export type ParticipantDistrictInfo = {
  isCorporate: boolean;
  participantType?: { id: number; name: string };
  districtName: string;
  isDivision: boolean;
  divisions: BKDistrictInfo[];
  isBKDistrict: boolean;
};

export type PhoneDetails = { contactNumber: string; extension: string };

export type AddressDetails = {
  lineText: string;
  additionalLineText: string | undefined;
  cityName: string;
  stateCode: string;
  postalCode?: string;
  county: {
    id: null | number;
    name: string;
  };
  country: {
    id: number;
    name: string;
  } | null;
  isPrimary: boolean;
  careOf: string;
};

export type ParticipantSchema = {
  id?: number;
  participantId?: number;
  participantType: {
    id: number;
    name: string;
  };
  participantRoleType: {
    id: number;
    name: string;
  };

  taxpayerIdentifierType: string;
  taxpayerIdentifierValue: string;
  fullName: string;
  title: string;
  prefix: string;
  firstName: string;
  middleName: string;
  lastName: string;
  suffix: string;
  isMarried: boolean;
  contactPointTelephoneValue: PhoneDetails[] | null;
  contactPointRoleType: string | null;
  contactPointOtherValue: null;
  contactPointFaxValue: string[] | null;
  contactPointEmailValue: string[] | null;
  addresses: AddressDetails[] | null;
  note: string;
  companyName: string;
  federalTaxId: string;
  isCorporate: boolean;
  isMilitary: boolean;
  militaryEffectiveDate: string | null;
  militaryExpirationDate: string | null;
  deceased: boolean;
  dateOfDeath: string | null;
  estateName: string;
  isEstateFiled: boolean;
  isProbateOpen: boolean;
  isProbateClaimPeriodOpen: boolean;
  referenceNumber: string;
  referenceName: string;
  code: string;
  loanIdentifier: string;
  actionName: string;
  mersorganizationIdentifier: string;
  mersoriginalMortgageeOfRecordIndicator: string;
  mersregistrationType: string;
  startDate: string;
  isActive: boolean;
};

export type GetParticipantPayload = {
  isCorporate?: boolean;
  participantType?: keyof AllParticipantModel;
  participantRole?: string;
};

export type ParticipantList = {
  id: number;
  createdBy: string;
  createdById: number;
  modifiedBy: string;
  modifiedById: number;
  createdDateTime: string;
  participantData: ParticipantSchema;
  participantType: string;
  isActive: boolean;
};

export type ParticipantUpdateModel = {
  id: number;
  participantData: ParticipantSchema;
};

export type ParticipantsListFilter = {
  isCorporate?: boolean;
  participantType?: string;
  participantRole?: string;
};

export type ParticipantOptionsList = {
  id: number;
  participantType: string;
  participantRoleType: string;
  isCorporate: boolean;
  name: string;
  address: string;
};

export type CreateCaseParticipantPayload = {
  caseNumber: string;
  participantId: number[];
};

export type treeLeafParticpiantLookupModel = {
  key: string;
  label: string;
  data: ParticipantOptionsList;
};

export type TreeParentParticpiantLookupModel = {
  key: string;
  label: string;
  data: any;
  children: treeLeafParticpiantLookupModel[];
};

export type CaseParticipantTreeLookup = {
  [AllParticipants.Client]: {
    key: '1';
    label: AllParticipants.Client;
    alias: 'client';
    data: null;
    children: treeLeafParticpiantLookupModel[];
  };
  [AllParticipants.PlainTiff]: {
    key: '2';
    label: AllParticipants.PlainTiff;
    alias: 'plainTiff';
    data: null;
    children: treeLeafParticpiantLookupModel[];
  };
  [AllParticipants.CourtDesignation]: {
    key: '3';
    label: AllParticipants.CourtDesignation;
    alias: 'courtDesignation';
    data: null;
    children: treeLeafParticpiantLookupModel[];
  };
  [AllParticipants.Vendor]: {
    key: '4';
    label: AllParticipants.Vendor;
    alias: 'vendor';
    data: null;
    children: treeLeafParticpiantLookupModel[];
  };
  [AllParticipants.CaseDesignation]: {
    key: '5';
    label: AllParticipants.CaseDesignation;
    alias: 'caseDesignation';
    data: null;
    children: treeLeafParticpiantLookupModel[];
  };
};

export type DivisionInfo = {
  divisionId?: string | null;
  division: DropDownNameOptions;
  court: DropDownNameOptions;
  judges: DropDownNameOptions[];
};

export type BKDistrictCreateModel = {
  district: DropDownNameOptions;
  hasDivision: boolean;
  divisions: DivisionInfo[] | null;
};

export type BKDistrictModel = {
  id: number;
  district: BKDistrictCreateModel;
};

export type BKDistrictUpdateModel = {
  id: number;
  bkDistrict: BKDistrictCreateModel;
};

export type CaseParticipantBkDistrictPayload = {
  districtId: number;
  divisionId?: number;
  courtId?: number;
};

export type CaseBkDistrict = {
  district: DropDownNameOptions;
  division: DropDownNameOptions;
  court: DropDownNameOptions;
  judges: DropDownNameOptions[];
};

export type CaseBkDistrictPayload = {
  caseNumber: string;
  bkDistrict: BKDistrictCreateModel;
};

export type CaseBkDistrictList = BKDistrictCreateModel[];

export type BkDelete = {
  districtId: number;
  divisionId: string | null;
};

export enum CaseParticipantModes {
  Patricipant = 'Participant',
  BKDistrict = 'BKDistrict',
}

export type CaseParticipantDelete = {
  caseNumber: string;
  participantId: number;
};

export type BkDistrictList = {
  id: number;
  districtId: number;
  divisionId: string | null;
  districtName: string;
  divisionName: string | null;
  courtName: string | null;
  judgeName: string | null;
};

export type CaseBkDelete = {
  caseNumber: string;
  districtId: number;
};

export type CreatePartcipantRequest = {
  participantData: ParticipantSchema;
  caseNumber: string | null;
};
